import { gql } from '~/src/generated/portal/gql';

const GET_API_TEST_PLANS = gql(`
  query getApiTestPlans($partnerId: String!, $sortBy: APITestPlanSorting) {
    apiTestPlans(partnerId: $partnerId, sortBy: $sortBy) {
      id
      name
      description
      partnerId
      providerId
      platform {
        platform
      }
      environment
      created
      updated
      publishedStatus
      executionStatus {
        status
        lastRun
      }
    }
  }
`);

export { GET_API_TEST_PLANS };
